import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "优圣聚富管理系统", -1);
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "系统首页", -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "产品管理", -1);
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "订单管理", -1);
import { ref, toRefs, computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { menuStore } from '@/store/Menu';
export default {
  __name: 'MyMenu',
  props: ['isClose'],
  setup(__props) {
    const state = menuStore();
    const menuData = ref(null);
    const menuActive = computed(() => state.menuActive);

    //定义开关
    // const isCollapse = ref(false)
    //使用路由
    const route = useRoute();
    const activeMenu = () => {
      let {
        path,
        meta
      } = route; //route

      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    };
    // 菜单的展开事件
    const open = (index, indexPath) => {};
    onMounted(() => {
      state.setMenuClass(menuData.value);
    });
    return (_ctx, _cache) => {
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      const _component_Briefcase = _resolveComponent("Briefcase");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_Grid = _resolveComponent("Grid");
      const _component_el_menu_item_group = _resolveComponent("el-menu-item-group");
      const _component_el_sub_menu = _resolveComponent("el-sub-menu");
      const _component_el_menu = _resolveComponent("el-menu");
      return _openBlock(), _createBlock(_component_el_menu, {
        "default-active": activeMenu(),
        class: "el-menu-vertical-demo",
        collapse: __props.isClose,
        "background-color": "#92e3c0",
        "text-color": "white",
        ref_key: "menuData",
        ref: menuData,
        "active-text-color": "#3a3a3a",
        "default-openeds": _unref(menuActive),
        router: "",
        onOpen: open
      }, {
        default: _withCtx(() => [_createVNode(_component_el_menu_item, null, {
          title: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          index: "/"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_Briefcase)]),
            _: 1
          }), _createTextVNode(), _hoisted_2]),
          _: 1
        }), _createVNode(_component_el_sub_menu, {
          index: "/goods"
        }, {
          title: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_Grid)]),
            _: 1
          }), _hoisted_3]),
          default: _withCtx(() => [_createVNode(_component_el_menu_item_group, null, {
            default: _withCtx(() => [_createVNode(_component_el_menu_item, {
              index: "/goods/list"
            }, {
              default: _withCtx(() => [_createTextVNode("产品列表")]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_sub_menu, {
          index: "/order"
        }, {
          title: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_Grid)]),
            _: 1
          }), _hoisted_4]),
          default: _withCtx(() => [_createVNode(_component_el_menu_item_group, null, {
            default: _withCtx(() => [_createVNode(_component_el_menu_item, {
              index: "/order/orderlist"
            }, {
              default: _withCtx(() => [_createTextVNode("订单列表")]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["default-active", "collapse", "default-openeds"]);
    };
  }
};